import Vue from 'vue'
export default {   //异步
    getIndexHeight({commit},h) { // commit 提交；name即为点击后传递过来的参数    	
    	return	commit ('getIndexHeight',h);
	},
	setJustAdmit({commit},n){//是否直接进入准入申请
		return	commit ('setJustAdmit',n);
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js